const searchInit = () => {
	document.querySelectorAll('.header__search-input').forEach((el) => {
		el.addEventListener('input', (e) => {
			const search = e.target.closest('.header__search').querySelector('.header__top-results');
			if (e.target.value) {
				search.classList.remove('hidden');
			} else {
				search.classList.add('hidden');
			}
		});
	});
};
export default searchInit;
